import { useEffect, useState } from 'react';

import * as Sentry from '@sentry/react';
import clsx from 'clsx';

import { UIConnector } from 'shared/store/web3-clients-store';

export function ConnectorButton({
  connector,
  onClick,
}: {
  connector: UIConnector;
  onClick: () => void;
}) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (typeof connector.getProvider === 'function') {
          const p = await connector.getProvider();
          if (!alive) return;
          setReady(Boolean(p));
        } else {
          if (!alive) return;
          setReady(true);
        }
      } catch {
        if (!alive) return;
        setReady(true);
      }
    })();
    return () => {
      alive = false;
    };
  }, [connector]);

  const vertical = typeof connector.getProvider === 'function';

  return (
    <button
      type="button"
      className={clsx(
        'flex',
        vertical ? 'flex-col' : 'flex-row',
        'items-center justify-center gap-1 rounded-lg border-[1px] border-border bg-move-icon-content px-1 py-2 text-[10px] text-white disabled:cursor-not-allowed disabled:opacity-50 sm:justify-start sm:gap-4 sm:rounded-3xl sm:p-4 sm:text-[24px]',
      )}
      disabled={!ready}
      aria-disabled={!ready}
      onClick={() => {
        Sentry.setTag('wallet', connector.name);
        onClick();
      }}
    >
      {connector.icon && (
        <img
          src={connector.icon}
          alt={connector.name}
          className="h-8 w-8 sm:h-[56px] sm:w-[56px]"
        />
      )}
      {connector.name}
    </button>
  );
}
